import { promotionsURL } from './promotions-api';
export const promotionsCacheKey = ({ accountId, accountIdType }) => [promotionsURL, { accountId, accountIdType }];
//# sourceMappingURL=promotions-cache-keys.js.map